import { PROJECT_TYPE_KIND } from '@src/constants/project';
import audioIcon from '@src/assets/images/audio.svg';
import subtitleIcon from '@src/assets/images/subtitle.svg';
import slideIcon from '@src/assets/images/slide.svg';
import videoIcon from '@src/assets/images/video.svg';

// The card's own smaller artwork; same kinds as PROJECT_TYPE_ICONS.
export const CARD_ICONS = {
  [PROJECT_TYPE_KIND.VIDEO]: videoIcon,
  [PROJECT_TYPE_KIND.SRT]: subtitleIcon,
  [PROJECT_TYPE_KIND.SLIDE]: slideIcon,
  [PROJECT_TYPE_KIND.AUDIO]: audioIcon,
};
